import CatalogAside from "widgets/catalog-aside/widget";
import SalePoint from "widgets/sale-point/widget";
import Scheme from '../Scheme';
import filter from 'lodash/filter';
import find from 'lodash/find';
import Zoom from '../Zoom';
import { salePointsPromise } from '../promises';
import qs from 'qs';

let Barba = require('barba.js');

module.exports = Barba.BaseView.extend({
    namespace: 'map-page',

    onEnterCompleted: function () {
        let aside = new CatalogAside(null, {
            cancelTransition: true
        });
        let salePoint = new SalePoint();
        let query = qs.parse(location.search, {ignoreQueryPrefix: true});

        if (query.search) {
            $('#map-search').val(query.search);
            $('.js_sale-point_search-icon').addClass('search__icon_clear');
        }

        aside.on('select', () => {
            salePoint.changePointsContent(document.location.search.slice(1));
        });

        let schemas = this.schemas = [];

        salePointsPromise.then(({items: allPoints}) => {
            $('.map__scheme').each(function () {
                let el = $(this);
                let scheme = new Scheme(el);
                let points = filter(allPoints, {schemaId: el.data('id')});

                scheme.addPoints(points);
                schemas.push(scheme);

                salePoint.points.forEach(point => {
                    scheme.highlightPoint(point.id);
                });

                scheme.on('select', point => {
                    schemas.forEach(el => {
                        if (el.id !== point.schemaId) {
                            el.unSelectPoint();
                        }
                    });
                    salePoint.showPoint(point.id);
                });
                scheme.on('unSelect', (point, toggle) => {
                    if (!toggle) {
                        salePoint.hidePoint();
                    }
                });

                salePoint.on('change', points => {
                    scheme.unHighlightPoints();
                    scheme.unSelectPoint();
                    filter(points, {schemaId: el.data('id')}).forEach(point => {
                        scheme.highlightPoint(point.id);
                    });
                });
            });

            salePoint.on('select', id => {
                let scheme = find(schemas, {id: id.schemaId});

                if (scheme) {
                    scheme.selectPoint(id.id);
                }
            });
            salePoint.on('unSelect', id => {
                if(id.schemaId) {
                    let scheme = find(schemas, {id: id.schemaId});

                    if (scheme) {
                        scheme.unSelectPoint();
                    }
                }
            });

            if (query.default_point_id) {
                let pointId = parseInt(query.default_point_id);
                let point = find(allPoints, {id: pointId});

                if (point) {
                    let scheme = find(schemas, {id: point.schemaId});

                    if (scheme) {
                        scheme.selectPoint(pointId);
                    }

                    salePoint.showPoint(pointId);
                }
            }
        });

        this.zoom = new Zoom($('.map__area'), {
            zoomBlock: $('.map__holder')
        });

        let onResize = this.onResize = () => {
            let holder = $('.map__holder');

            this.updateViewPortHeight();
            holder.data('initialWidth', holder.parent()[0].offsetWidth);
            this.zoom.zoom(1, false);
        };

        $(window).resize(onResize);
        onResize();

        $('.map__zoom-btn_minus').click(() => {
            this.zoom.zoom(0.66);
        });
        $('.map__zoom-btn_plus').click(() => {
            this.zoom.zoom(1.5);
        });
        $('.header__search').hide();
    },

    onLeave: function () {
        this.schemas.forEach(schema => schema.destroy());
        this.zoom.destroy();
        $('.header__search').show();
    },

    updateViewPortHeight: function () {
        let area = $('.map__area');
        let mapBlock = $('.map');
        let top = parseFloat(getComputedStyle(mapBlock[0]).paddingTop);

        area.css('height', window.innerHeight - top);
    },

    onResize: function () {}
});



// WEBPACK FOOTER //
// resources/assets/src/js/views/map-page.js